import VueHighcharts from 'vue2-highcharts'
import Highcharts from 'highcharts'

export default {
  name: 'MixedChart',
  props: {
    analyzeTargetCode: String,
    historyId: Number,
    chartOption: Object
  },
  components: {
    VueHighcharts: VueHighcharts
  },
  mounted () {

  },
  data: () => ({
    Highcharts: Highcharts,
    basicData: {
      chart: {
        zoomType: 'xy'
      },
      title: {
        text: 'ABCL分析'
      },
      xAxis: [{
        categories: [
          '国産牛カタ焼肉用', '米国産　牛タン焼肉', '十勝黒牛ランプステーキ', 'かみふらの和牛カタしゃぶ', '豪州牛バラ焼肉　１００ｇ', '豪州牛肩ロース切りおとし'],
        crosshair: true,
        labels: {
          format: '{value} %'
        }
      }],
      yAxis: [
        { // Primary yAxis
          labels: {
            format: '{value}%',
            style: {
              color: Highcharts.getOptions().colors[1]
            }
          },
          title: {
            text: '点数構成比',
            style: {
              color: Highcharts.getOptions().colors[1]
            }
          }
        },
        { // Secondary yAxis
          title: {
            text: 'リピート率',
            style: {
              color: Highcharts.getOptions().colors[0]
            }
          },
          labels: {
            format: '{value} %',
            style: {
              color: Highcharts.getOptions().colors[0]
            }
          },
          opposite: true
        }
      ],
      tooltip: {
        shared: true
      },
      legend: {
        layout: 'vertical',
        align: 'left',
        x: 120,
        verticalAlign: 'top',
        y: 100,
        floating: true,
        backgroundColor: (Highcharts.theme && Highcharts.theme.legendBackgroundColor) || '#FFFFFF'
      },
      series: [{
        name: '点数構成比',
        type: 'column',
        yAxis: 1,
        data: [49.9, 71.5, 106.4, 129.2, 144.0, 176.0],
        tooltip: {
          valueSuffix: ' %'
        }
      },
      {
        name: 'リピート率',
        type: 'spline',
        data: [7.0, 6.9, 9.5, 14.5, 18.2, 21.5],
        tooltip: {
          valueSuffix: '%'
        }
      }]
    }
  })
}
